/**
 * Redux-sagaのメイン
 * Redux-sagaはAPIの非同期処理を行う
 */
import { all, AllEffect } from '@redux-saga/core/effects';
import { call, Effect } from 'redux-saga/effects';
import shopListSaga from './shopList/shopListSaga';
import shopSaga from './shopList/shopSaga';
import scheduleSaga from './schedule/scheduleSaga';
import visitorRegisterSaga from './visitorRegister/VisitorRegisterSaga';
import simpleAuthSaga from './simpleAuth/simpleAuthSaga';
import reserveHistorySaga from './reserveHistory/reserveHistorySaga';

// 他のRedux-sagaを組み立てる
export default function* rootSagas(): Generator<AllEffect<Effect>> {
  yield all([
    call(shopListSaga),
    call(shopSaga),
    call(scheduleSaga),
    call(visitorRegisterSaga),
    call(simpleAuthSaga),
    call(reserveHistorySaga),
  ]);
}
